import { atom } from "recoil";

export const QuyHoachState = atom({
  key: "QuyHoachState",
  default: {
    loaiQuyHoach: "ALL",
    quyhoachId: null,
    tableData: {},
  },
});
